import React from "react";
import MenuItem from "@mui/material/MenuItem";

import { useSnackbar } from "components/haven-design/snackbar";
import { useInterestsTable } from "../interests-table/table-context";
import { getBulkLimitError, MAX_BULK_ACTION_APPLICANTS } from "./utils";

type Props = {
  selectedInterestIds: string[];
  closeMenu: () => void;
  setSkipModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const SkipButton: React.FC<Props> = (props) => {
  const { closeMenu, setSkipModalOpen } = props;
  const { openSnackbar } = useSnackbar();
  const { totalSelectedInterests } = useInterestsTable();

  const open = () => {
    // Select-all and page ranges are allowed as long as the selection fits the cap.
    const error = getBulkLimitError(totalSelectedInterests, {
      empty: "Please select an applicant to skip.",
      overLimit: `At most ${MAX_BULK_ACTION_APPLICANTS} applicants can be skipped at once`,
    });
    if (error) {
      setTimeout(() => openSnackbar({ message: error, status: "error", duration: 5000 }), 100);
    } else {
      setSkipModalOpen(true);
    }
    closeMenu();
  };

  return (
    <MenuItem id="actions-skip-applicants" onMouseUp={open}>
      Skip Applicants {`(${totalSelectedInterests})`}
    </MenuItem>
  );
};

export default SkipButton;
